// app/src/lib/media.js — resolve a job/genome media reference to a fetchable URL.
//
// TODAY (the local rig): result.video is an absolute LOCAL path — the dev server serves it
// at /files/<runId>/<basename>. IN PROD: result.video is a gs:// ref, which a browser cannot
// fetch — the signed-URL/CDN delivery seam is a NAMED D2 follow-up (see the D1 report §gaps);
// until it lands this returns null for gs:// and the UI shows the honest "not fetchable yet"
// note instead of a broken player.

export function mediaUrl(ref, runId) {
  if (!ref) return null;
  const s = String(ref);
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('gs://')) return null; // the prod delivery seam (D2) — never guess a public URL
  if (s.startsWith('/') && runId) {
    const base = s.split('/').pop();
    return `/files/${encodeURIComponent(runId)}/${encodeURIComponent(base)}`;
  }
  if (runId) return `/files/${encodeURIComponent(runId)}/${encodeURIComponent(s)}`;
  return null;
}
